export enum TreeNodeType {
    Survey = 1,
    Component = 2,
    Dimension = 3,
    Question = 4,
    Answer=5
}
